<template>
  <div class="plv-ia-rpr-cell" :class="{ error: showError }">
    <div class="plv-ia-rpr-cell__left">
      <i v-if="specialTitle">{{ specialTitle }}</i>
      <span v-if="required" class="plv-ia-rpr-cell__left--required">*</span>
      <span>{{ title }}：</span>
    </div>
    <div
      class="plv-ia-rpr-cell__right"
      @mouseenter="$emit('mouseenter')"
      @mouseleave="$emit('mouseleave')"
    >
      <div v-if="cellType === CELL_TYPES.input" class="plv-ia-rpr-cell__input">
        <input
          v-model="inputVal"
          :maxlength="maxLen"
          :type="inputType"
          :placeholder="placeholder"
          @input="handleInputChanged"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
        />
        <span>{{ unit }}</span>
        <slot name="input"></slot>
      </div>
      <div v-if="cellType === CELL_TYPES.max" class="plv-ia-rpr-cell__num">
        <input
          v-model="inputVal"
          :type="inputType"
          :placeholder="placeholder"
          @input="handleInputChanged"
          @compositionstart="handleInputStart"
          @compositionend="handleInputEnd"
        />
        <span>{{ value.length }}/{{ maxLen }}</span>
      </div>
      <div
        v-if="cellType === CELL_TYPES.select"
        class="plv-ia-rpr-cell__select"
      >
        <el-select
          :value="value"
          placeholder="请选择"
          @change="handleOptionChanged"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="showError && errorTip" class="plv-ia-rpr-cell-error">
        {{ errorTip }}
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export const CELL_TYPES = {
  input: 'input',
  max: 'max',
  select: 'select'
};
export default {
  name: 'redpacketCell',
  mixins: [Locale],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    required: {
      type: Boolean,
      default: false
    },
    specialTitle: {
      type: [String, null],
      default: null
    },
    title: {
      type: String,
      default: '标题'
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    cellType: {
      type: String,
      default: CELL_TYPES.input,
      validator(str) {
        return CELL_TYPES[str];
      }
    },
    inputType: {
      type: String,
      default: 'text'
    },
    /** 是否为整数 */
    isRound: {
      type: Boolean,
      default: false
    },
    /** 是否为正数 */
    isPositive: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: '元'
    },
    maxLen: {
      type: Number,
      required: false,
      default: 999
    },
    max: {
      type: Number,
      required: false,
      default: 999
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: [String, Number],
      default: ''
    },
    errorTip: {
      type: [String, null],
      default: null
    }
  },
  data() {
    return {
      CELL_TYPES,
      showError: false,
      inputVal: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal === undefined) return;
        this.inputVal = newVal;
      }
    }
  },
  methods: {
    handleOptionChanged(option) {
      this.$emit('change', option);
    },
    handleInputChanged(e) {
      if (this.inputMethod) return;
      let val = e.target.value;
      // 如果是max
      if (this.cellType === CELL_TYPES.max && val.length >= this.maxLen) {
        val = val.slice(0, this.maxLen);
      }
      let finalVal = val;
      if (this.isRound) {
        finalVal = val.replace(/[^\d]|\./g, '');
        this.inputVal = finalVal;
      } else {
        if (this.isPositive) {
          val = val.replace(/-/g, '');
        }
        this.inputVal = val;
        finalVal = this.inputType === 'number' && val ? Number(val) : val;
      }
      this.$emit('change', finalVal);
    },
    handleInputStart() {
      this.inputMethod = true;
    },
    handleInputEnd(e) {
      this.inputMethod = false;
      this.handleInputChanged(e);
    }
  }
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss">
.plv-ia-rpr-cell {
  margin-top: 18px;
  display: flex;
  &.error {
    .plv-ia-rpr-cell__right {
      input {
        border-color: red;
      }
    }
  }
}

.plv-ia-rpr-cell__left {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  word-break: keep-all;
  white-space: nowrap;
  flex-shrink: 0;
  i {
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    font-style: normal;
    background: #ff5b5b;
    //margin-right: 4px;
    border-radius: 2px;
  }
  span {
    font-size: 14px;
    color: #333;
    line-height: 19px;
    vertical-align: middle;
  }
}

.plv-ia-rpr-cell__right {
  // flex: 1;
  width: 312px;
  flex-shrink: 0;
  input {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 25px 0 8px;
    color: #333;
    background: none;
    border-radius: 2px;
    border: 1px solid #cfd8dc;
    outline: none;
  }
}

.plv-ia-rpr-cell__input {
  position: relative;
  span {
    position: absolute;
    font-size: 14px;
    color: #333;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.plv-ia-rpr-cell__num {
  position: relative;
  input {
    padding-right: 42px;
  }
  span {
    position: absolute;
    font-size: 12px;
    color: #9e9e9e;
    right: 8px;
    top: 10px;
    line-height: 20px;
  }
}

.plv-ia-rpr-cell__select {
  .el-select {
    width: 100%;
    .el-input__inner {
      padding: 0 15px;
      box-sizing: border-box;
    }
  }
}

.plv-ia-rpr-cell__left--required {
  color: #ff3a30 !important;
}
input::-webkit-input-placeholder {
  color: #dfdddd;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
